var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var ChevronLeftIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 40,
    glyphHeight: 64,
    glyphOffsetX: -4
  }), React.createElement("path", {
    d: "M32.3232 0L38.8571 6.46857L13.0678 32L38.8571 57.5543L32.3232 64L0 32L32.3232 0Z"
  }));
};
export var ChevronLeftIconGlyph = function (props) {
  return React.createElement(ChevronLeftIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};